import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentageAmount'
})
export class PercentageAmountPipe implements PipeTransform {
  transform(value: number | undefined): string {
    if (value || value === 0) {
      return value.toFixed(2) + ' %';
    }
    return '-';
  }
}
